import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {PagerDataObject} from "../../entities/pagerDataObject";
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CompanyService } from 'src/app/services/company.service';
import { Company } from 'src/app/entities/company';
import {NgxSpinnerService} from 'ngx-spinner';
import {CompanyFormComponent} from "./company-form.component";
import {UserService} from "../../services/user.service";

@Component({
    selector: 'app-company',
    templateUrl: './company.component.html',
    styleUrls: ['./company.component.css'],
    standalone: false
})
export class CompanyComponent implements OnInit {

 
  metaInfo: string[];
  columns: Array<any>;
  data: PagerDataObject;
  @Input()
  headers = [' ', 'Name', 'TaxId', 'First Name', 'Last Name'];
  @Input()
  disableHeader = false;
  subscription: any;
  private dataSub$ = new Subject<any>();
  query: String;
  company: Company = new Company();
  @ViewChild('addForm', { static: true })
  public addForm:CompanyFormComponent
  user

  ngOnInit(): void {
      this.company.properties = {}
  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  constructor(private companyService: CompanyService,
              private spinner: NgxSpinnerService,
              public userService: UserService) {
    this.spinner.show();
    this.subscription = this.dataSub$.pipe(switchMap(filter => {
      return this.companyService.getData(filter);
    }))
      .subscribe(data => {
        this.data = data;
        this.spinner.hide();
      });
    this.metaInfo = this.companyService.getMetaInfo();
    this.columns = this.companyService.getColumns();
    this.loadData()
  }

  loadData() {
    this.userService.getCurrentUser().subscribe(user => {
        this.user = user;
    });
  }

  onGridQuery(query) {
    this.query = query
    this.dataSub$.next(query);
  }

  deleteCompany(entity){
    // let company = new Company();
    // company.id = entity;
    this.companyService.delete$(entity)
      .subscribe(service => {
        this.dataSub$.next(this.query);
      });
  }

}
